import { AppInfoListItemComponent } from 'app/components/shared/app-info-list-item/app-info-list-item.component';
import { AppPrefixPipe } from './pipes/app-prefix.pipe';
import { CommonModule } from '@angular/common';
import { DetailsPageHeaderDirective } from './directives/details-page-header.directive';
import { DetailsPageSectionDirective } from './directives/details-page-section.directive';
import { DirectivesModule } from 'app/directives/directives.module';
import { InfoListItemComponent } from './components/info-list-item/info-list-item';
import { InsightsHeaderComponent } from './components/insights-header/insights-header.component';
import { InsightsSectionContainerComponent } from './components/insights-section/insights-section-container.component';
import { NgModule } from '@angular/core';
import { PipesModule } from 'app/pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/components/shared/shared.module';
import { ShowIfPipe } from './pipes/show-if.pipe';
import { SideNavigationComponent } from './components/side-navigation/side-navigation.component';
import { SideNavItemDirective } from './components/side-navigation/side-navigation-item.directive';
import { SuggestFeedbackModule } from 'app/components/suggest-feedback/suggest-feedback.module';
import { HideIfInvalidPipe } from './pipes/hide-if-invalid.pipe';
import { ClawbackNotificationComponent } from './components/clawback-notification/clawback-notification.component';
import { ClawbackTimelineComponent } from './components/clawback-timeline/clawback-timeline.component';

@NgModule({
  declarations: [
    InfoListItemComponent,
    AppInfoListItemComponent, // hack to get around cyclic dependency
    SideNavigationComponent,
    SideNavItemDirective,
    DetailsPageHeaderDirective,
    DetailsPageSectionDirective,
    InsightsHeaderComponent,
    ClawbackNotificationComponent,
    ClawbackTimelineComponent,
    AppPrefixPipe,
    InsightsSectionContainerComponent,
    ShowIfPipe,
    HideIfInvalidPipe
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    PipesModule,
    RouterModule,
    SharedModule,
    SuggestFeedbackModule
  ],
  exports: [
    InfoListItemComponent,
    AppInfoListItemComponent, // hack to get around cyclic dependency
    SideNavigationComponent,
    DetailsPageHeaderDirective,
    DetailsPageSectionDirective,
    InsightsHeaderComponent,
    ClawbackNotificationComponent,
    ClawbackTimelineComponent,
    AppPrefixPipe,
    InsightsSectionContainerComponent,
    ShowIfPipe,
    HideIfInvalidPipe
  ],
  providers: []
})
export class DetailsPageModule {}
